import React, { useState, useEffect } from "react";

function DataList(props) {
  const [data, setData] = useState([]);
  const [credentialSubject, setCredentialSubject] = useState("");

  useEffect(() => {    
    setData(props.details);
  }, []);

  const formatKeys = (data) => {
    let formattedData = JSON.stringify(data);
    formattedData = Array.isArray(data) ? [] : {};

    Object.keys(data).forEach((key) => {
      const formattedKey =
        key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");

      if (typeof data[key] === "object" && data[key] !== null) {
        formattedData[formattedKey] = formatKeys(data[key]);
      } else {
        formattedData[formattedKey] = data[key];
      }
    });
    return formattedData;
  };

  function isArrayOfStrings(arr) {
    return Array.isArray(arr) && arr.every((item) => typeof item === "string");
  }

  const renderTableRows = (data, level) => {
    return Object.entries(data).map(([key, value]) => {
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          if (isArrayOfStrings(value)) {
            return (
              <React.Fragment key={key}>
                <tr style={{width: "100%", display: "inline-block"}}>
                  <td
                    className="col-1"
                    style={{
                      fontWeight: 400,
                      paddingLeft: "30px",
                    }}
                  >
                    {key}
                  </td>
                  <td className="col-2"></td>
                </tr>
                {value.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td className="col-1"></td>
                        <td className="col-2">{item}</td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            );
          } else {
            const formattedKey =
                key.charAt(0).toUpperCase() +
                key.slice(1).replace(/_/g, " ");
            return (
              <React.Fragment key={key}>
                <tr style={{width: "100%", display: "inline-block"}}>
                  <td className="col-1">{formattedKey}</td>
                  <td className="col-2"></td>
                </tr>
                {value.map((item, index) => (
                  <React.Fragment key={index}>
                    {renderTableRows(item, 1)}
                  </React.Fragment>
                ))}
              </React.Fragment>
            );
          }
        } else {
          const formattedKey =
            key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
          return (
            <React.Fragment key={key}>
              <tr style={{width: "100%", display: "inline-block"}}>
                <td className="col-1">{formattedKey}</td>
                <td className="col-2"></td>
              </tr>
              {renderTableRows(value, 1)}
            </React.Fragment>
          );
        }
      } else {
        let levelPadding = 10 + level * 20;
        let fontWeight;
        if (levelPadding > 10) fontWeight = 400;

        const formattedKey =
          key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");

        let formattedValue = value;
        return (
          <tr style={{width: "100%", display: "inline-block"}}>
            <td
              className="col-1"
              style={{
                fontWeight: fontWeight,
                paddingLeft: levelPadding + "px",
              }}
            >
              {formattedKey}
            </td>
            <td style={{maxWidth:"400px"}} className="col-2"><p style={{whiteSpace: "initial", overflowWrap: "break-word"}}>{formattedValue ? formattedValue : "/"}</p></td>
          </tr>
        );
      }
    });
  };

  return (
    <div className="datalist-container">
      <table className="table">
        <tbody style={{width: "100%", display: "inline-block"}}>
          <tr style={{width: "100%", display: "inline-block"}}>
            <td className="col-1">Identifier</td>
            <td style={{maxWidth:"400px"}} className="col-2">
            <p style={{whiteSpace: "initial", overflowWrap: "break-word"}}>{props.credentialData.credential.credentialIdentifier}</p>
            </td>
          </tr>

          {renderTableRows(data)}

          <tr style={{width: "100%", display: "inline-block"}}>
            <td className="col-1">Issuer</td>
            <td className="col-2">
              {props.credentialData.credential.issuer.name}{" "}
            </td>
          </tr>
          <tr style={{width: "100%", display: "inline-block"}}>
            <td className="col-1">Valid from</td>
            <td style={{maxWidth:"400px"}} className="col-2">
                <p style={{whiteSpace: "initial", overflowWrap: "break-word"}}>{props.credentialData.credential.issuanceDate.split("T")[0]}{" "}</p>
            </td>
          </tr>

          {/*<tr>
                <td className="col-1">Valid to</td>
                <td className="col-2">
                <UTC utc={data.issuanceDate} />
                </td>
            </tr>*/}

          {props.credentialData.credential.id && (
            <tr>
              <td className="col-1">Id</td>
              <td style={{maxWidth:"400px"}} className="col-2">
                <p style={{whiteSpace: "initial", overflowWrap: "break-word"}}>{props.credentialData.credential.id}</p></td>
            </tr>
          )}

          <tr>
            <td className="col-1">Version</td>
              <td style={{maxWidth:"400px"}} className="col-2">
                <p style={{whiteSpace: "initial", overflowWrap: "break-word"}}>{props.credentialData.version}</p></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default DataList;
